<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="flex flex-align-center gap-sm">
          <app-back-button [ariaLabel]="'settings.back' | translate" />
          <span>{{ 'settings.services.title' | translate }}</span>
        </div>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      @if (services().length === 0) {
        <p class="empty-state" data-testid="services-empty">{{ 'settings.services.empty' | translate }}</p>
      } @else {
        <ul class="service-list" data-testid="service-list">
          @for (service of services(); track service.id) {
            <li class="service-row flex flex-align-center flex-justify-space-between gap-sm" [attr.data-testid]="'service-row-' + service.id">
              <div class="flex flex-align-center gap-sm">
                <span class="service-label">{{ service.label }}</span>
                @if (service.default_price != null) {
                  <span class="service-price">${{ service.default_price.toFixed(2) }}</span>
                } @else {
                  <span class="service-no-price">{{ 'settings.services.noPrice' | translate }}</span>
                }
                @if (!service.is_active) {
                  <span class="service-inactive-badge">{{ 'settings.services.inactive' | translate }}</span>
                }
              </div>
              <div class="flex gap-xs">
                <app-button variant="text" (click)="toggleActive(service)" [attr.data-testid]="'toggle-service-' + service.id">
                  {{ (service.is_active ? 'settings.services.deactivate' : 'settings.services.activate') | translate }}
                </app-button>
                <app-button variant="text" (click)="openEdit(service)" [attr.data-testid]="'edit-service-' + service.id">
                  <app-icon name="pencil" [size]="14" />
                </app-button>
              </div>
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions>
      <app-button variant="filled" (click)="openCreate()" data-testid="new-service-button">
        <app-icon name="plus" />
        {{ 'settings.services.new' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>

@if (showEditor()) {
  <app-modal-dialog (backdropClick)="closeEditor()">
    <div header>
      <div class="heading-md">{{ (editing() ? 'settings.services.editTitle' : 'settings.services.newTitle') | translate }}</div>
    </div>
    <div content>
      @if (error()) {
        <div class="error-container p-md" data-testid="service-form-error">{{ error() }}</div>
      }
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" />
      </form>
    </div>
    <div footer>
      <app-button variant="text" (click)="closeEditor()" data-testid="cancel-service-button">
        {{ 'settings.services.cancel' | translate }}
      </app-button>
      <app-button variant="filled" color="primary" [disabled]="saving()" (click)="save()" data-testid="save-service-button">
        {{ 'settings.services.save' | translate }}
      </app-button>
    </div>
  </app-modal-dialog>
}
